const VIEW_TOKEN_KEY = 'adminToken'
const PROFILE_BIO_KEY = 'viewUserBio'
const PROFILE_EMAIL_KEY = 'userEmail'
const PROFILE_CREATE_TIME_KEY = 'userCreateTime'
const PROFILE_LAST_LOGIN_KEY = 'userLastLoginTime'
const PREFERENCES_KEY = 'viewUserPreferences'

function notifyViewAuthChanged() {
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event('view-auth-changed'))
	}
}

export function getViewToken() {
	return window.localStorage.getItem(VIEW_TOKEN_KEY) || ''
}

export function isViewLoggedIn() {
	return !!getViewToken()
}

export function getViewUser() {
	return {
		username: window.localStorage.getItem('username') || '',
		nickname: window.localStorage.getItem('nickname') || window.localStorage.getItem('username') || '用户',
		avatar: window.localStorage.getItem('userAvatar') || '/img/avatar.jpg',
		role: window.localStorage.getItem('role') || 'ROLE_user',
		email: window.localStorage.getItem(PROFILE_EMAIL_KEY) || '',
		createTime: window.localStorage.getItem(PROFILE_CREATE_TIME_KEY) || '',
		lastLoginTime: window.localStorage.getItem(PROFILE_LAST_LOGIN_KEY) || '',
		bio: window.localStorage.getItem(PROFILE_BIO_KEY) || '',
	}
}

export function saveViewUserProfile(profile = {}) {
	if (profile.nickname !== undefined) {
		window.localStorage.setItem('nickname', profile.nickname || '')
	}
	if (profile.avatar !== undefined) {
		window.localStorage.setItem('userAvatar', profile.avatar || '/img/avatar.jpg')
	}
	if (profile.email !== undefined) {
		window.localStorage.setItem(PROFILE_EMAIL_KEY, profile.email || '')
	}
	if (profile.bio !== undefined) {
		window.localStorage.setItem(PROFILE_BIO_KEY, profile.bio || '')
	}
	notifyViewAuthChanged()
}

export function setViewAuthFromLogin(data = {}, fallbackUsername = '') {
	const token = data.token || ''
	const user = data.user || {}
	if (token) {
		window.localStorage.setItem(VIEW_TOKEN_KEY, token)
	}
	const username = user.username || fallbackUsername || ''
	window.localStorage.setItem('username', username)
	window.localStorage.setItem('nickname', user.nickname || username || '用户')
	window.localStorage.setItem('userAvatar', user.avatar || '/img/avatar.jpg')
	window.localStorage.setItem('role', user.role || 'ROLE_user')
	if (user.email) {
		window.localStorage.setItem(PROFILE_EMAIL_KEY, user.email)
	}
	if (user.createTime) {
		window.localStorage.setItem(PROFILE_CREATE_TIME_KEY, String(user.createTime))
	}
	window.localStorage.setItem(PROFILE_LAST_LOGIN_KEY, String(Date.now()))
	notifyViewAuthChanged()
}

export function clearViewAuth() {
	[
		VIEW_TOKEN_KEY,
		'username',
		'nickname',
		'userAvatar',
		'role',
		PROFILE_EMAIL_KEY,
		PROFILE_CREATE_TIME_KEY,
		PROFILE_LAST_LOGIN_KEY,
		PROFILE_BIO_KEY,
	].forEach(key => window.localStorage.removeItem(key))
	notifyViewAuthChanged()
}

export function getViewPreferences() {
	try {
		const raw = window.localStorage.getItem(PREFERENCES_KEY)
		if (!raw) {
			return {
				themeMode: 'light',
				showTimeline: true,
				compactMoments: false
			}
		}
		return {
			themeMode: 'light',
			showTimeline: true,
			compactMoments: false,
			...JSON.parse(raw)
		}
	} catch (e) {
		return {
			themeMode: 'light',
			showTimeline: true,
			compactMoments: false
		}
	}
}

export function saveViewPreferences(preferences = {}) {
	const value = {
		...getViewPreferences(),
		...preferences
	}
	window.localStorage.setItem(PREFERENCES_KEY, JSON.stringify(value))
	notifyViewAuthChanged()
	return value
}
